(ns minorodata.app-admin.model
  (:require [mold.core :as m :include-macros true]))

(m/defmodel admin-data
  {:clients         [::m/vector "List of clients"]
   :client-response [::m/map "Client response"]
   :user-response   [::m/map "User response"]
   :connectors      [::m/vector "List of connectors"]

   :current-tab     [::m/string "Currently selected tab"]
   :client-configs  [::m/vector "List of client configs"]}
  {:singleton true})


(m/defmodel connector-editor-tab
  {:tab-id [::m/string ::m/identity "Tab ID"]
   :tab-title [::m/string "Tab title"]
   :connector-data [::m/map "Initial connector data"]
   :edited-connector [::m/map "Connector after editing by the user"]
   :layout-configuration [::m/map "A flat map of all UI configurations"]})

;; list of tabs [{:tab-id "uuid" :title "title"}]
;;
;; tab data models
;; {:tab-id "uuid"
;;  :form-data {:lots of data from connector}
;;  :current-tab "general"
;;  :split-position 100
;;  :dark-mode-preview-toggle falsE}
